const SortIndicator = ({ column = "", settings = {
  key: "",
  direction: ""
} }) => {
  let classNames = "sort";
  if (settings.direction == "DESC") {
    classNames += " desc";
  }
  return (column == settings.key ? <span class={classNames}></span> : "");
};

export default SortIndicator;